/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_No_Record_SelectedInputs */



/**
* | output |
* | --- |
* | "No record selected" |
*
* @param {Explorer_Info_No_Record_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_no_record_selected = /** @type {((inputs?: Explorer_Info_No_Record_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_No_Record_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun enregistrement selectionne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein Datensatz ausgewählt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun record selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Запись не выбрана")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay ningún registro seleccionado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未选择记录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("レコードが選択されていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई रिकॉर्ड चयनित नहीं हुआ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum registro selecionado")
	return /** @type {LocalizedString} */ ("No record selected")
});